import createModel from 'utils/model'
import {getGroupMembers, getGroupDetails, getGroupStat} from 'crm/services/group-list'
import _ from 'lodash'

export default createModel({
    namespace: 'crm_groupListGroupMember',

    state: {
        stat: null,
        details: null,
        tableList: {},
        selectedRowKeys: [],
        selectedRows: [],
    },

    effects: {
        *getGroupMembers({payload}, {select, put, call}) {
            const {tableList} = yield select(
                ({crm_groupListGroupMember}) => crm_groupListGroupMember,
            )

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }

            const res = yield call(getGroupMembers, {id: payload?.id, params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *getGroupDetails({payload}, {put, call}) {
            const res = yield call(getGroupDetails, payload)

            yield put({
                type: 'setProperty',
                payload: {
                    details: res.data,
                },
            })

            return res
        },

        *getGroupStat({payload}, {put, call}) {
            const res = yield call(getGroupStat, payload)

            yield put({
                type: 'setProperty',
                payload: {
                    stat: res.data,
                },
            })

            return res
        },
    },
})
